import {QUICK_SEARCH} from "@/core/services/store/users.module";

export function runQuickSearchTabRequest(vm, type) {
  const token = ++vm.requestToken;
  vm.isQueryLoaded = true;

  return vm.$store
      .dispatch(QUICK_SEARCH, {
        q: vm.query,
        page: vm.page,
        type: type,
        activityLog: vm.page === 1,
      })
      .then(data => {
        if (token !== vm.requestToken) {
          return;
        }
        if (!data || !data.records) {
          if (vm.page === 1) {
            vm.queryData = [];
            vm.totalRecords = 0;
          }
          return;
        }
        vm.queryData = vm.queryData.concat(data.records.data || []);
        vm.page = data.records.current_page;
        vm.lpage = data.records.last_page;
        vm.totalRecords = data.records.total;
      })
      .catch(() => {
        if (token !== vm.requestToken) {
          return;
        }
        if (vm.page === 1) {
          vm.queryData = [];
          vm.totalRecords = 0;
        }
      })
      .finally(() => {
        if (token === vm.requestToken) {
          vm.isQueryLoaded = false;
        }
      });
}
